import { BaseEdge, EdgeLabelRenderer, getBezierPath, useReactFlow } from '@xyflow/react'

/**
 * Custom edge with a × delete button that appears on hover/select.
 */
export function DeleteEdge({
  id, sourceX, sourceY, targetX, targetY,
  sourcePosition, targetPosition,
  selected, markerEnd, style,
}) {
  const { deleteElements } = useReactFlow()

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition,
    targetX, targetY, targetPosition,
  })

  const deleteEdge = (e) => {
    e.stopPropagation()
    // Through the delete pipeline (not a bare setEdges filter) so the
    // canvas's onBeforeDelete snapshots it — Ctrl+Z restores the wire
    // like any other deletion (ENG-878).
    deleteElements({ edges: [{ id }] })
  }

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: selected ? '#ff8866' : '#e07040',
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: '6 3',
          filter: selected ? 'drop-shadow(0 0 4px #ff8866)' : 'none',
        }}
      />

      {/* Delete button — always visible on selected, visible on hover via CSS */}
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: 'all',
            opacity: selected ? 1 : 0,
            transition: 'opacity 0.15s',
          }}
          className="edge-delete-btn-wrap"
        >
          <button
            onClick={deleteEdge}
            title="Disconnect"
            style={{
              width: 18, height: 18,
              borderRadius: '50%',
              background: '#c03020',
              border: '1px solid #ff6050',
              color: '#fff',
              fontSize: 11,
              lineHeight: '16px',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: 0,
            }}
          >
            ×
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  )
}
